import React, { useEffect } from 'react';

/**
 * Public privacy policy page.
 * With HashRouter, use: https://aashman.in/#/privacy-policy
 */
function PrivacyPolicy() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Privacy Policy | Aashman Technicals';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <section className="privacy-policy-page" aria-labelledby="privacy-policy-title">
      <div className="container">
        <div className="legal-page-header">
          <h1 id="privacy-policy-title">Privacy Policy</h1>
          <p className="legal-page-subtitle">
            Aashman Technicals Pvt. Ltd.
          </p>
          <p className="legal-page-meta">
            We respect your privacy and process your data responsibly.
          </p>
        </div>

        <div className="legal-page-body">
          <article className="legal-card">
            <h2>Overview</h2>
            <p>
              This Privacy Policy explains how Aashman Technicals collects, uses, stores, and protects
              your personal information when you use our website, app, and related services.
            </p>
          </article>

          <article className="legal-card">
            <h2>Information We Collect</h2>
            <ul>
              <li>Contact details such as name, phone number, and email address.</li>
              <li>Business and address information submitted in forms.</li>
              <li>Device, usage, and service performance data where applicable.</li>
            </ul>
          </article>

          <article className="legal-card">
            <h2>How We Use Information</h2>
            <p>
              We use your data to provide support, process requests, improve products, communicate updates,
              and meet legal or regulatory obligations.
            </p>
          </article>

          <article className="legal-card">
            <h2>Data Security</h2>
            <ul>
              <li>We apply reasonable technical and organisational safeguards.</li>
              <li>Access is restricted to authorised personnel and systems.</li>
              <li>No internet transmission or storage system is absolutely secure.</li>
            </ul>
          </article>

          <article className="legal-card">
            <h2>Your Rights</h2>
            <ul>
              <li>You can request access, correction, or update of your personal details.</li>
              <li>You can contact us for privacy-related questions or concerns.</li>
            </ul>
          </article>

          <div className="legal-note">
            <p>
              For official legal terms related to TRUNNA bookings, visit the
              Terms &amp; Conditions page.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
